export default {
  CRM_VALUE: 0,
  CRM_SIMPLIFIED_VALUE: 1,
  CRM_AUTOMATIC_VALUE: 2,
};
